import { DgtPdOrderPicklist } from '../../models'
import Modal from '../Modal'
import DataGrid, { 
  SelectColumn
} from 'react-data-grid'
import { useState } from 'react'
import { writeFile, utils } from 'xlsx';

import CheckboxFormatter from '../../formatters/CheckboxFormatter'
import { getFragranceItems } from '../../apis'

const GenerateExcelFragranceModal = ({ 
  show, onClose, bulkOrders, filename
} : { 
  show: boolean,
  onClose: () => void,
  bulkOrders: DgtPdOrderPicklist[],
  filename: string
}) => {
  
  const [selectedRows, setSelectedRows] = useState<ReadonlySet<string>>(() => new Set(
    bulkOrders.map(ord => ord.extraReturnId ? `${ord.pk}#${ord.extraReturnId}` : ord.pk)
  ));
  const [ loading, setLoading ] = useState<boolean>(false)
  const getDataAndExport = async () => {
    setLoading(true)

    const results = await getFragranceItems(Array.from(selectedRows).map(row => {
      const split = row.split('#')
      return {
        orderNo: split[0],
        extraId: split.length > 1 ? split[1] : undefined
      }
    }))

    const workbook = utils.book_new();

    const summaryTabRows = Object.keys(results).map(matCode => {
      return {
        'Material Code': matCode,
        'Description': results[matCode][0].materialDescription,
        'Order': '',
        'Total Qty': results[matCode].reduce((acc : number, item : any) => acc + (item['requestQty'] || item['qty']), 0),
        'Unit': results[matCode][0].materialUnit,
        'Note': ''
      }
    })

    for(const matCode of Object.keys(results)) {
      const rows = results[matCode].map((item : any) => ({
        'Order': item['pk'] || item['orderId'], // A
        'Qty': item['requestQty'] || item['qty'], // B 
        'Unit': item['materialUnit'], // C
        'Note': item['orderId'] ? 'เบิกเพิ่ม' : ''
      }))

      const ws = utils.json_to_sheet(rows, { origin: 'A1'})

      const totalRowIdx = rows.length + 2
      const lastRowIdx = rows.length + 1
      utils.sheet_set_array_formula(ws, `B${totalRowIdx}`, `SUM(B2:B${lastRowIdx})`);

      const firstItem = results[matCode][0]
      
      utils.book_append_sheet(workbook, ws, `${matCode} - ${firstItem.materialDescription}`);

      const totalRows = results[matCode].map((item : any) => ({
        'Material Code': '',
        'Description': '',
        'Order': item['pk'] || item['orderId'],
        'Total Qty': item['requestQty'] || item['qty'],
        'Unit': '',
        'Note': item['orderId'] ? 'เบิกเพิ่ม' : ''
      }))

      summaryTabRows.splice(summaryTabRows.findIndex(row => row['Material Code'] === matCode) + 1, 0, ...totalRows, {
        'Material Code': '',
        'Description': '',
        'Order': '',
        'Total Qty': '',
        'Unit': '',
        'Note': ''
      })
    }

    const summaryWorkSheet = utils.json_to_sheet(summaryTabRows)
    utils.book_append_sheet(workbook, summaryWorkSheet, 'Summary')
    
    writeFile(workbook, `น้ำหอม_${filename}.xlsx`);
    setLoading(false)
    onClose()
  }

  return show ? <Modal
    title={'Export ยอดเบิกน้ำหอม (108, 109)'}
    maxWidth={'max-w-2xl'}
    show={show}
    onHide={onClose}>
    <div className='space-y-3 '>
      <p>กำลังจะ Export จาก {selectedRows.size} order(s)</p>
      <DataGrid
        columns={[ 
          SelectColumn, 
          { key: 'pk', name: 'Order', width: 100 },
          { key: 'materialCode', name: 'Code', width: 100 },
          { key: 'materialDescription', name: 'Description' },
          { key: 'commentText', 'name': 'Note', width: 200 }
        ]}
        rows={bulkOrders}
        style={{ height: 'fit-content' }}
        selectedRows={selectedRows}
        onSelectedRowsChange={setSelectedRows}
        rowKeyGetter={row => row.extraReturnId ? `${row.pk}#${row.extraReturnId}` : row.pk}
        components={{ checkboxFormatter: CheckboxFormatter }}
      />
      <div className="flex w-full gap-2 pt-4">
        <button
          type="button"
          className={` btn-outline-secondary basis-1/2`}
          onClick={onClose}
        >
          ยกเลิก
        </button>
        <button
          type="submit"
          className='btn-success basis-1/2'
          onClick={getDataAndExport}
          disabled={loading}
        >
          {loading ? `Loading...`: 'Export'}
        </button>
      </div>
    </div>
  </Modal> : null
}

export default GenerateExcelFragranceModal